import pushToDataLayer from "@ecom/ui/utils/pushToDataLayer"
import { apiFetch } from "@ecom/ui/utils/api"
import { events } from "./events"
import { API_BASE_URL } from "./api"

export const sendRequest = (
  path = "/v2/app/public/start",
  data: Record<string, any>,
  phoneValidate = false
) =>
  apiFetch(`${API_BASE_URL}${path}`, {
    method: phoneValidate ? "PUT" : "POST",
    credentials: "include",
    referrerPolicy: "origin-when-cross-origin",
    headers: {
      "X-Referer-Path": window?.location?.pathname,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res: Response) => {
      if (!res.ok) {
        throw Error(`HTTP error. Status code: ${res.status}`)
      }

      return res.json()
    })
    .catch((err: Error) => {
      console.error("error while sending request:", err)

      pushToDataLayer(events.GAFormEvent.error)

      return Promise.reject(err)
    })
